import React from 'react';
import { Button } from './ui/button';
import { MessageCircle } from 'lucide-react';

const FloatingCTA = ({ onClick }) => {
  return (
    <div className="hidden lg:block fixed bottom-6 right-6 z-50">
      <Button
        onClick={onClick}
        size="lg"
        className="shadow-2xl h-14 px-6 text-base font-semibold rounded-full hover:scale-105 transition-transform"
      >
        <MessageCircle className="w-5 h-5 mr-2" />
        Обсудить задачу
      </Button>
    </div>
  );
};

export default FloatingCTA;

